import { render } from "./Updates.vue?vue&type=template&id=364b20a8"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"
script.render = render

export default script